import { IFormField } from '../IForm.types';
import { ItemForm } from './ItemForm';

export class InputNumberForm extends ItemForm {
  inputType= 'number';
  type= 'number';
  placeholder= '';

  constructor(field: IFormField) {
    super(field);
  }
}
